const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PlanningQueryURL: any = {
    GetPlanningPageData: Backofficebff + '/v1/shotdelivery/get',
    GetPlannings: Backofficebff + '/v1/shotdelivery/planings',
    GetPlanById: Backofficebff + '/v1/shotdelivery/planings',
    GetPlanningShots: Backofficebff + '/v1/shotdelivery/planing-shots',
};
